export var PlacementType;
(function (PlacementType) {
    PlacementType["GLOBAL_BANNER"] = "globalBanner";
    PlacementType["HOME_PAGE_WIDGET"] = "homePageWidget";
    PlacementType["NOTIFICATION_DRAWER"] = "drawer";
    PlacementType["PAGE_BANNER"] = "pageBanner";
    PlacementType["NOTIFICATION_FEED"] = "feed";
    PlacementType["IN_CONTEXT"] = "inContext";
    PlacementType["UCM_CAMPAIGNS_SUGGESTED_TACTICS"] = "ucmCampaignsSuggestedTactics";
    PlacementType["UCM_OPPORTUNITY_PAGE_PRIMARY"] = "ucmOpportunityPagePrimary";
    PlacementType["UCM_CAMPAIGNS_GUIDANCE_COLUMN"] = "ucmCampaignsGuidanceColumn";
    PlacementType["BRAND_METRICS_PAGE"] = "brandMetricsPage";
    PlacementType["CC_EGRESS"] = "ccEgress";
})(PlacementType || (PlacementType = {}));
export function toPlacementType(value) {
    return Object.values(PlacementType).includes(value) ? value : undefined;
}
